export default theme => ({
  root: {
    overflow: 'auto'
  },
  deleteColor: {
    color: theme.palette.danger.main,
  }
});

